export const artistInterviewVideos = [
    {name: 'Angelique Nagovskaya', url: 'https://youtu.be/tmExsGnKrs8?si=QVEPCnsOH7Jy_EsS'},
    {name: 'Vivia Wisperwind', url: 'https://youtu.be/ZLQ7c_bPmO4?si=A0lXnM7Xz9ga7wMh'},
    {name: 'Anthony Webb', url: 'https://youtu.be/fPU6K5_Y-gs?si=6EFHhLLzWPsEB6TC'},
    {name: 'Alexander Rhys', url: 'https://youtu.be/9YGfzMr13pQ?si=B2la1j9U3qvyfh0z'},
    {name: 'Marta Tesoro', url: 'https://youtu.be/45BNTfLhwco?si=T2kQz1O6OwMehZw9'},
    {name: 'Trev Clarke', url: 'https://youtu.be/rx_cX_IFJWE?si=lPehJgoFShKDDDSK'},
    {name: 'Brighton Royal Pavilion', url: 'https://youtu.be/kl73VU99P-A?si=WdSc88EVLZFshl2o'},
    {name: 'Barbara Safran de Niverville', url: 'https://youtu.be/5hcYt5gVM0E?si=xKHngXj3-Cab20Ar'},
    {name: 'Painted Lady Studio', url: 'https://youtu.be/e1AtXnuOuag?si=4QOcB5aSXlXNrL-1'},
    {name: 'Jo Vincent', url: 'https://youtu.be/rDwZ-JZ9S7M?si=YrHbBrQji1R4EvNc'},
    {name: 'Christian Redermayer', url: 'https://youtu.be/DFwwdIGGMIg?si=f6gBTTdOTAPxYogh'},
    {name: 'Paul Gittins', url: 'https://youtu.be/mPfiYdlogyQ?si=Aj-4dfm8pNJVRmRm'},
    {name: 'Guille Giagante', url: 'https://youtu.be/v3TqXu7hb6s?si=RJO3G_obQZzq6BSZ'},
    {name: 'Ethan Platt', url: 'https://youtu.be/RbPUK9j6WBg?si=GI3VOXp8G6KQ6hhw'},
];

export const artistInterviewLinks = {
    ...Object.fromEntries(artistInterviewVideos.map(({name, url}) => [name, url])),
    'Ant Webb': 'https://youtu.be/fPU6K5_Y-gs?si=6EFHhLLzWPsEB6TC',
    'Melissa Hamlyn': 'https://youtu.be/e1AtXnuOuag?si=4QOcB5aSXlXNrL-1',
};

export function getYouTubeVideoId(interviewUrl) {
    if (!interviewUrl) {
        return null;
    }

    try {
        const parsedUrl = new URL(interviewUrl);

        if (parsedUrl.hostname.includes('youtu.be')) {
            return parsedUrl.pathname.replace('/', '');
        }

        if (parsedUrl.hostname.includes('youtube.com')) {
            if (parsedUrl.pathname.startsWith('/embed/')) {
                return parsedUrl.pathname.replace('/embed/', '');
            }

            return parsedUrl.searchParams.get('v');
        }

        return null;
    } catch (error) {
        return null;
    }
}

export function getYouTubeThumbnailUrl(interviewUrl) {
    const videoId = getYouTubeVideoId(interviewUrl);

    if (!videoId) {
        return null;
    }

    return `https://i.ytimg.com/vi/${videoId}/sddefault.jpg`;
}

export async function getYouTubeOEmbedData(interviewUrl) {
    const response = await fetch(`https://www.youtube.com/oembed?url=${encodeURIComponent(interviewUrl)}&format=json`);

    if (!response.ok) {
        throw new Error(`Failed to load YouTube metadata: ${response.status}`);
    }

    return response.json();
}

export function getArtistInterviewEmbedUrl(artistName) {
    const interviewUrl = artistInterviewLinks[artistName];

    if (!interviewUrl) {
        return null;
    }

    try {
        const videoId = getYouTubeVideoId(interviewUrl);

        if (!videoId) {
            return null;
        }

        return `https://www.youtube.com/embed/${videoId}`;
    } catch (error) {
        return null;
    }
}
